import { CourtDayType, DayOfWeek, MonthlyOrdinal } from "@/api";

export interface CourtDayFormValue {
  type: CourtDayType;
  weekday: DayOfWeek | null;
  ordinal: MonthlyOrdinal | null;
  dates: Array<Date | null>;
}

export interface CourtFormType {
  name: string;
  shortCode: string;
  fileNumberPrefix: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  country: string;
  districts: number[];
  courtDays: CourtDayFormValue[];
}

/** Max lengths mirror the backend `Court` entity constants. Address field lengths are shared — see `AddressFieldMaxLength`. */
export const CourtMaxLength = {
  name: 255,
  shortCode: 12,
} as const;

/** Vienna district courts use 4-digit Austrian postal codes (mirrors `Court.ZipCodeLength`). */
export const CourtZipCodeLength = 4;

/** The 3-digit court segment of the Aktenzahl (mirrors `Court.FileNumberPrefixLength`). */
export const CourtFileNumberPrefixLength = 3;
